import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-the-g01-content-point__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_G01ItemListGroup = _resolveComponent("G01ItemListGroup")!
  const _component_TheG01Content = _resolveComponent("TheG01Content")!

  return (_openBlock(), _createBlock(_component_TheG01Content, {
    categories: _ctx.categories,
    class: "p-the-g01-content-point",
    "is-category": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, key) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (category.sku_set.length > 0)
              ? (_openBlock(), _createBlock(_component_G01ItemListGroup, {
                  key: key,
                  "category-id": category.category_id,
                  "category-label": category.category_name,
                  items: category.sku_set,
                  "is-category": false,
                  "is-first": category.is_first,
                  class: "p-the-g01-content-point__list__item"
                }, null, 8, ["category-id", "category-label", "items", "is-first"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ]),
    _: 1
  }, 8, ["categories"]))
}